import { render, staticRenderFns } from "./TurnSummary.vue?vue&type=template&id=0e2fd2c6&lang=pug&"
import script from "./TurnSummary.vue?vue&type=script&lang=js&"
export * from "./TurnSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports